import type { GetCourseDraftAssets200PageableSort } from './getCourseDraftAssets200PageableSort';

/**
 * Spring Data Pageable 정보
 */
export type GetCourseDraftAssets200Pageable = {
  /** 요청된 페이지 번호 */
  page?: number;
  /** 요청된 페이지 크기 */
  size?: number;
  /** Spring Data Sort 정보 */
  sort?: GetCourseDraftAssets200PageableSort;
};
